export default __webpack_public_path__ + "static/media/img--hero.7344c179.jpg";